<template>
  <b-navbar toggleable="md" type="dark" variant="info">

    <b-nav-toggle target="nav_collapse"></b-nav-toggle>

    <b-navbar-brand href="#"></b-navbar-brand>

    <b-collapse is-nav id="nav_collapse">

      <b-nav is-nav-bar>
        <b-nav-item><router-link to="/" exact tag="span">Home</router-link></b-nav-item>
        <b-nav-item><router-link to="/about" tag="span">About</router-link></b-nav-item>
      </b-nav>


    </b-collapse>
  </b-navbar>

  <!-- navbar-1.vue -->
</template>

<script>
export default {
  mounted() {
      let self = this;
      self.axios.get(ApibaseUrl+"api/v1/menus/mainmenu").then((response) => {
         self.menus = response.data;
      })
  },
  data () {

    return {
      menus:[]
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Navbar.vue